import React from 'react';
import ImageSlider from './ImageSlider';
import BlurredImageSlider from './BlurredImageSlider';
import CoverPageSlider from './CoverPageSlider';

const SliderComponent = ({ 
    className = '', 
    images = [], 
    sizes = '100vw', 
    withNavigation = false, 
    loadPrevNext = false, 
    thumbsPosition = "top", 
    autoPlay = false, 
    nested = false, 
    slidesPerView = 1, 
    spaceBetween = 0, 
    sliderType = '', 
    sliderStyle = 'Crop' 
}) => {
    if (sliderType === 'coverPage') {
        return (
            <CoverPageSlider
                className={className}
                images={images}
                sizes={sizes}
                withNavigation={withNavigation}
                loadPrevNext={loadPrevNext}
                thumbsPosition={thumbsPosition}
                autoPlay={autoPlay}
                nested={nested}
                slidesPerView={slidesPerView}
                spaceBetween={spaceBetween}
            />
        );
    }

    if (sliderStyle === 'Blur') {
        return (
            <BlurredImageSlider
                className={className}
                images={images}
                sizes={sizes}
                withNavigation={withNavigation}
                loadPrevNext={loadPrevNext}
                thumbsPosition={thumbsPosition}
                autoPlay={autoPlay}
                nested={nested}
                slidesPerView={slidesPerView}
                spaceBetween={spaceBetween}
            />
        );
    }

    return (
        <ImageSlider
            className={className}
            images={images}
            sizes={sizes}
            withNavigation={withNavigation}
            loadPrevNext={loadPrevNext}
            thumbsPosition={thumbsPosition}
            autoPlay={autoPlay}
            nested={nested}
            slidesPerView={slidesPerView}
            spaceBetween={spaceBetween}
        />
    );
};

export default SliderComponent; 